export const Translated = {
    name: 'Translated',
    value: 'TRANSLATED',
    sequence: 1,
};
export const NotTranslated = {
    name: 'Not Translated',
    value: 'NOT_TRANSLATED',
    sequence: 2,
};
const Basic = [Translated, NotTranslated];
const BasicByValue = Basic.reduce((hash, status) => {
    hash[status.value] = status;
    return hash;
}, {});
const BasicProps = Object.keys(BasicByValue);
export default {
    Basic,
    BasicByValue,
    BasicProps,
    Translated,
    NotTranslated,
};
